<template>
    <span class="fight-round-name-base-style" :class="fightRoundClass">
        {{ translatedFightRoundName }}
    </span>
</template>

<script setup lang="ts">
    import { computed } from "vue";
    import { translate } from "./translations";

    const props = defineProps<{
        roundName: string;
        bracketLevel: number;
    }>();

    const fightRoundClass = computed<string>(() => {
        if (props.roundName === "final") {
            return "fight-round-final";
        }
        if (props.roundName === "semi_final") {
            return "fight-round-semi-final";
        }
        if (props.roundName === "quarter_final") {
            return "fight-round-quarter-final";
        }
        if (props.roundName === "third_place_playoff") {
            return "fight-round-3rd-place-playoff";
        }
        if (props.roundName === "repechage_3rd_place") {
            return "fight-round-3rd-place-playoff";
        }
        if (props.roundName === "elimination_for_3rd_place") {
            return "fight-round-elimination_for_3rd_place";
        }
        return "";
    });

    const translatedFightRoundName = computed<string>(() => {
        const translated = translate(props.roundName, true);
        if (props.roundName === "repechage") {
            return `${translated} ${props.bracketLevel}`;
        }
        return translated;
    });
</script>

<style scoped>
    /**
     * Fight round styles are generated via SCSS mixin in:
     * app/Frontend/Bulma/components/_fight-round.scss
     */
</style>
